module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "content",
    staticClass: "hz-m-wrap"
  }, [_c('img', {
    staticClass: "hz-u-img",
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "add-item",
      rawName: "v-add-item"
    }],
    staticClass: "hz-m-area"
  }, _vm._l((_vm.zones), function(zone, index) {
    return _c('zone', {
      key: index,
      staticClass: "hz-m-item",
      attrs: {
        "index": index,
        "setting": zone
      },
      on: {
        "delItem": function($event) {
          return _vm.removeItem($event)
        },
        "changeInfo": function($event) {
          return _vm.changeInfo($event)
        }
      }
    })
  }), 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5bf9f280", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf9f280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-hotzone/lib/components/Hotzone.vue
// module id = 2748
// module chunks = 0